import { gql, graphQueryBang } from "shared/lib/graphql"
import allISOs from "./user_iso_codes.js"

const geographicQuery = gql`
  query(
    $service: String!
    $metric_start_date: DataServiceDate!
    $metric_end_date: DataServiceDate!
  ) {
    service_metrics(
      channel_module_name: $service
      metric_start_date: $metric_start_date
      metric_end_date: $metric_end_date
    ) {
      metrics {
        service_countries_count {
          country_iso
          connected
          disconnected
          active
          power
          addressable
          growth_count
          growth_perc
        }
      }
    }
  }
`

// we can't use 0 values with logarithmic color scale on the map
// TODO: find a more elegant solution
export const logScaleHack = value => value || 0.1
export const logScaleHackFixer = value => (value === 0.1 ? 0 : value)

export default function userGeoMetricsFetcher(
  serviceModuleName,
  userType,
  { currentMetricDate }
) {
  return graphQueryBang(geographicQuery, {
    service: serviceModuleName,
    metric_start_date: currentMetricDate,
    metric_end_date: currentMetricDate,
  }).then(data => {
    const allCountryData =
      data.service_metrics.metrics[0].service_countries_count

    return allISOs.map(iso => {
      const countryData =
        allCountryData.find(cd => cd.country_iso === iso.code) || {}
      return {
        code: iso.code,
        name: iso.name,
        connected: countryData.connected || 0,
        disconnected: countryData.disconnected || 0,
        active: countryData.active || 0,
        power: countryData.power || 0,
        addressable: countryData.addressable || 0,
        growthCount: countryData.growth_count || 0,
        growthPercentage: countryData.growth_perc || 0,
      }
    })
  })
}
